<template>
  <div class="background">
    <el-row style="height: 10%; margin-bottom: 20px">
      <el-col span="16">
        <div class="haeders" style="margin: 13px 0 0 20px" @click="returnIndex">票务后台首页</div>
      </el-col>
      <el-col span="5" style="margin-top: 10px">
        <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="input2"
            style="padding: 0;" size="small"
        >
        </el-input>
      </el-col>
      <el-col span="1" class="style2" style="margin-left: 10px">
        <i style="size: 12px" @click="searchReservationInfo">搜索</i>
      </el-col>
    </el-row>
    <el-row style="height: 70%;">
      <el-col :span="15">
        <el-row style="height: 10%;">
          <el-col :span="11" style="border-radius: 30px;margin-left: 20px" class="border">
            <el-col :span="12">
              <div class="text4" style="margin: 13px 0 0 20px;">今日预约人数</div>
              <div class="text3" style="margin: 13px 0 0 20px">昨日预约人数</div>
              <div class="text3" style="margin: 13px 0 0 20px">较昨日</div>
            </el-col>
            <el-col :span="12">
              <div style="text-align: right">
                <div class="text2" style="margin-top: 13px;text-align: right ">{{ nowReservationNum }}人</div>
                <div class="text3" style="margin-top: 13px;text-align: right">{{ yesReservationNum }}人</div>
                <div class="text3" style="margin-top: 13px;text-align: right">{{ compareNum }}人</div>
              </div>

            </el-col>
          </el-col>
          <el-col :span="11" style="border-radius: 30px; margin-left: 15px" class="border">
            <el-col :span="12">
              <div class="text4" style="margin: 13px 0 0 20px">今日销售总额</div>
              <div class="text1" style="margin: 13px 0 0 20px">
                <label class="labelStyle"></label>
                销售额
              </div>
              <div class="text3" style="margin: 13px 0 0 20px">￥{{totalAmount}}</div>
            </el-col>
            <el-col :span="12">
              <div class="text2" style="margin-top: 13px; text-align: right">￥{{ sales_volume }}</div>
              <div class="text1" style="margin-top: 13px; text-align: right">核销额</div>
              <div class="text3" style="margin-top: 13px; text-align: right">￥{{verification_amount}}</div>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="height: 10%; margin: 13px 0 13px  20px">
          <div class="haeders">
            快捷入口
          </div>
        </el-row>
        <el-row style="height: 10%;text-align: center">
          <el-col :span="5" class="border1" style="margin-left: 20px">
            <div class="text5">
              添加票种
            </div>
          </el-col>
          <el-col :span="5" class="border1" style="margin-left: 20px">
            <div class="text5">
              查看订单
            </div>
          </el-col>
          <el-col :span="5" class="border1" style="margin-left: 20px">
            <div class="text5">
              验券记录
            </div>
          </el-col>
          <el-col :span="5" class="border1" style="margin-left: 20px">
            <div class="text5">
              锁定预约时间
            </div>
          </el-col>
        </el-row>
        <el-row style="height: 60%; margin: 20px 0 20px 20px">
          <div style="background-color: #FFFFFF; width: 95%;height: 331px;border-radius: 20px;">
            <tendency></tendency>
          </div>

        </el-row>
      </el-col>
      <el-col :span="8" style="background-color: #FFFFFF; border-radius: 10px">
        <div>
          <el-calendar v-model="timeDate" @select="handleDateClick">
          </el-calendar>
        </div>
        <div class="text5" style="text-align: left; margin-left: 10px">已预约时间段</div>
        <el-row>
          <div>
            <el-col :span="6">
              <div class="style3" v-for="(time, index) in timePeriods">
                <div>{{ totalNumber }}</div>
                <div>人</div>
              </div>
            </el-col>
            <el-col :span="17">
              <div v-for="(time, index) in timePeriods">
                 <div style="margin-top: 10px">
                 <div >场次{{time}}</div>
                <el-col :span="18">已预约人数</el-col>
                <el-col :span="6">{{ currentNumber }}/{{ totalNumber }}</el-col>
              </div>

              <div style="margin-top: 40px">
                <el-progress :percentage="progressPercentage" :show-text="false" :color="progressColor"></el-progress>
              </div>
                </div>
            </el-col>

          </div>

        </el-row>
        <div class="buttonStyle">查看预约信息</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import tendency from './tendency'
import dtime from 'time-formater'
import {Calendar} from 'element-ui';
import $ from 'jquery'

export default {
  data() {
    return {
      userCount: null,
      orderCount: null,
      adminCount: null,
      allUserCount: null,
      allOrderCount: null,
      allAdminCount: null,
      sevenDay: [],
      sevenDate: [[], [], []],
      reservationNums: 0,
      input: '',
      currentNumber: 6, // 当前已预约人数，对应图中的6
      totalNumber: 2, // 总人数，对应图中的2，这里可能存在数据不合理的情况，假设总人数应该是10之类的
      progressPercentage: 0,
      progressColor: '#5C16F2',
      value: new Date(),
      nowReservationNum: 0,
      yesReservationNum: 0,
      compareNum: 0,
      totalAmount:0,
      sales_volume:0,
      verification_amount:0,
      timePeriods:[],
      timeDate:new Date(),
      value1:new Date(),
      input2:'',
    }
  },
  components: {
    tendency,
  },
  mounted() {
    this.calculatePercentage();
  },
  created() {
    this.reservationNum1();
    this.getPayAmount();
    this.reservationDate();
    this.reservationTime()
  },
  computed: {},
  methods: {
    searchReservationInfo(){},
    handleDateClick(date) {
      console.log('时间段555', date);
    },
    calculatePercentage() {
      // 计算进度百分比
      this.progressPercentage = this.currentNumber / this.totalNumber;
    },
    returnIndex() {
      this.$router.push('/manage');
    },
    reservationNum1() {
      var that = this
      console.log('日期', new Date())
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      // 获取月，需要注意月份是从0开始计数的，所以要加1
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      // 获取日
      const day = String(currentDate.getDate()).padStart(2, '0');
      // 组合成指定格式的日期字符串
      var formattedDate = `${year}-${month}-${day}`;
      this.value = formattedDate
      console.log('formattedDate', formattedDate)
      const storedSelectedSite = localStorage.getItem('selectedSite');
       console.log('storedSelectedSite', storedSelectedSite)
      $.ajax({
        url: this.$settings.BASE_URL + "reservation/num/info",
        type: 'POST',
        dataType: 'json',
        data: {'date': this.value},
          xhrFields: {
        withCredentials: true
    },
        success: (res) => {
          console.log('res666', res)
          if (res.info == 'ok' && res.result.reservation_sum.length > 0) {
            res.result.reservation_sum.forEach(function (orders) {
              if (orders.date == formattedDate) {
                that.nowReservationNum = orders.total_ticket_num
              } else {
                that.yesReservationNum = orders.total_ticket_num
              }
            })
            that.compareNum = res.result.num
          } else {
            that.reservationNums = 0
          }
        },
        error: (error) => {
          console.log('请求失败：', error)
        }
      })
    },
    getPayAmount() {
       var that = this
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      // 获取月，需要注意月份是从0开始计数的，所以要加1
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      // 获取日
      const day = String(currentDate.getDate()).padStart(2, '0');
      // 组合成指定格式的日期字符串
      const formatDate1 = `${year}-${month}-${day}`;
      this.value1 = formatDate1
      $.ajax({
        url: this.$settings.BASE_URL + "sales_volume/info",
        type: 'POST',
        dataType: 'json',
        data: {'date': this.value},
           xhrFields: {
        withCredentials: true
    },
        success: (res) => {
          console.log('res666', res)
          if (res.info == 'ok') {
            that.totalAmount = res.total_info.total
            that.sales_volume = res.total_info.sales_volume
            that.verification_amount = res.total_info.verification_amount
          }
           console.log('res63366', that.totalAmount)
        },
        error: (error) => {
          console.log('请求失败：', error)
           this.$message({
                        message: '请求有误，请联系管理员',
                        type: 'error',
                        onClose: () => {
                            // 跳转到登录页
                            // this.$router.push('/')
                        }
                    })
        }
      })
    },
    reservationDate(){
       const currentDate = new Date();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    console.log('minutes', minutes);
    let startHour = hours;
    if (minutes < 30) {
      startHour = minutes === 0? hours : hours;
    } else {
      startHour = hours + 1;
    }

     const formatTime = (hour, minute) => {
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    };
     const timePeriods = [];
    for (let i = 0; i < 3; i++) {
      const startMinute = i === 0? 0 : 30;
      const endMinute = startMinute === 0? 30 : 0;
      const endHour = startHour + (endMinute === 0? 1 : 0);
      const startTime = formatTime(startHour, startMinute);
      const endTime = formatTime(endHour, endMinute);
      const period = `${startTime}-${endTime}`;
      timePeriods.push(period);
      startHour = endHour;
    }
    this.timePeriods = timePeriods
    console.log('时间段', timePeriods);
    },
    reservationTime(){
      var that = this
      console.log('日期', new Date())
      const timePeriods = that.timePeriods
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      // 获取月，需要注意月份是从0开始计数的，所以要加1
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      // 获取日
      const day = String(currentDate.getDate()).padStart(2, '0');
      // 组合成指定格式的日期字符串
      var formattedDate = `${year}-${month}-${day}`;
      this.value = formattedDate
      console.log('formattedDate', formattedDate)
      const storedSelectedSite = localStorage.getItem('selectedSite');
       console.log('storedSelectedSite', storedSelectedSite)
      $.ajax({
        url: this.$settings.BASE_URL + "reservation/time/num/info",
        type: 'POST',
        dataType: 'json',
        data: {'date': that.value,'timePeriodsStart':timePeriods[0],'timePeriodsEnd':timePeriods[2]},
          xhrFields: {
        withCredentials: true
    },
        success: (res) => {
          console.log('res6777666', res)
          if(res.info=='ok'){
            this.currentNumber = 0
          }

        },
        error: (error) => {
          console.log('请求失败：', error)
        }
      })
    }
  }
}
</script>

<style lang="less">
@import '../style/mixin';

.data_section {
  padding: 20px;
  margin-bottom: 40px;

  .section_title {
    text-align: center;
    font-size: 30px;
    margin-bottom: 10px;
  }

  .data_list {
    text-align: center;
    font-size: 14px;
    color: #666;
    border-radius: 6px;
    background: #E5E9F2;

    .data_num {
      color: #333;
      font-size: 26px;

    }

    .head {
      border-radius: 6px;
      font-size: 22px;
      padding: 4px 0;
      color: #fff;
      display: inline-block;
    }
  }

  .today_head {
    background: #FF9800;
  }

  .all_head {
    background: #20A0FF;
  }
}

.wan {
  .sc(16px, #333)
}

.border {
  width: 280px;
  height: 130px;
  gap: 0px;
  border-radius: 20px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px #ECEFF7;

}

.haeders {
  width: 100px;
  height: 31px;
  font-family: PingFang SC sans-serif;
  font-size: 17px;
  font-weight: 600;
  line-height: 30.8px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #2D334A;
}

.border1 {
  width: 100px;
  height: 40px;
  //padding: 20px 30px 30px 20px;
  gap: 10px;
  border-radius: 15px;
  //opacity: 0px;
  background: #FFFFFF;

}

.background {
  background-color: #F4F5FA;
}

.text1 {
  width: 128px;
  height: 25px;
  font-family: PingFang SC sans-serif;
  font-size: 17px;
  font-weight: 600;
  line-height: 25.2px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #2D334A;

}

.text2 {
  width: 128px;
  height: 25px;
  font-family: PingFang SC sans-serif;
  font-size: 17px;
  font-weight: 600;
  line-height: 33.6px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #2D334A;
}

.text3 {
  width: 128px;
  height: 25px;
  font-family: PingFang SC sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 25.2px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #2D334A;

}

.text4 {
  width: 120px;
  height: 25px;
  font-family: PingFang SC sans-serif;
  font-size: 17px;
  font-weight: 600;
  line-height: 25.2px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #2D334A;
}

.el-calendar-day {
  padding: 3px;
}

.background {
  background-color: #F4F5FA;;
}


/* 使用自定义字体 */
body {
  font-family: 'PingFang SC', sans-serif; /* 应用自定义字体 */
}

.labelStyle {
  width: 15px;
  height: 15px;
  background: #5C16F2;
  border-radius: 20px 20px 20px 20px;
}

.text5 {
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 600;
  line-height: 30.8px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  padding: 5px;
  color: #2D334A;;
}

//.el-icon-date {
//  color: #5C16F2;
//  font-family: Inter;
//  font-size: 12px;
//  font-weight: 400;
//  line-height: 16.94px;
//  text-align: center;
//  text-underline-position: from-font;
//  text-decoration-skip-ink: none;
//  justify-items: center;
//  justify-content: center;
//  margin: 10px 0 0 10px;
//}

.style1 {
  width: Hug (68px)px;
  height: Fixed (29px)px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #5C16F2;
  text-align: center;
  justify-items: center;
  justify-content: center;
  margin: 0;
}

.style2 {
  width: Hug (44px)px;
  height: Fixed (29px)px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #5C16F2;
  text-align: center;
  justify-items: center;
  justify-content: center;
  color: #5C16F2;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.94px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 10px 30px 0 0;
  padding: 6px;

}

.el-calendar-table .el-calendar-day {
  box-sizing: border-box;
  padding: 20px !important; /* 强制覆盖 */
  height: 20px !important; /* 强制覆盖 */
}

.el-calendar-table td {
  border-bottom: 0 solid #EBEEF5 !important;
  border-right: 0 solid #EBEEF5 !important;
}

.buttonStyle {
  width: 180px;
  height: 35px;
  border-radius: 20px;
  background-color: #5C16F2;
  text-align: center;
  align-items: center;
  color: #FFFFFF;
  margin-top: 5px;
  margin-left: 100px;
  padding: 5px;
}

.style3 {
  width: 60.28px;
  height: 74px;
  border-radius: 30px;
  background: #D6D0FF80;
  text-align: center;
  justify-items: center;
  color: #5C16F2;
  margin: 10px 10px 0 10px;;
}

.el-calendar-table tr td:first-child {
  border-left: 0 solid #EBEEF5 !important;
}

.el-button {
  width: 34% !important;
  padding: 0 !important;
}

//.el-calendar__header {
//
//  border-bottom: 0px solid #EBEEF5 !important;
//}
.el-calendar {
  //border-bottom: 1px solid #EBEEF5 !important;
  flex: fit-content;
  width: 90%;
  height: 60%;
  margin-left: 10px;
}

//.el-progress-bar {
//  width: 80% !important;
//}

//.el-button-group{
//  width: 112px !important;
//  height: 24px !important;
//}
.el-calendar__header {
  //width: 280px !important;
  height: 24px !important;
  border-bottom: 0 solid #EBEEF5 !important;
}

.el-calendar__body {
  padding: 0 !important;
}

//.selected-date {
//  background-color: lightblue;
//  color: #5C16F2 !important;
//}


</style>
